module.exports = "/_next/static/images/RegionalSegment-743adcbe57cd8216dff98b86b83fe461.webp";